import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AccountLockoutDialogData {
	message: string;
	forgotPasswordUrl: string;
}

@Component({
	selector: 'account-lockout-dialog',
	templateUrl: './account-lockout-dialog.component.html',
	styleUrls: ['./account-lockout-dialog.component.scss'],
	standalone: false
})
export class AccountLockoutDialogComponent {

	constructor (
		private dialogRef: MatDialogRef<AccountLockoutDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AccountLockoutDialogData
	) {}

	public close () {
		this.dialogRef.close();
	}
}
